module.exports = __webpack_public_path__ + "static/img/home_fn_content_09.9dd296c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_09.png
// module id = 0D6K
// module chunks = 34